// src/store/index.ts
import { configureStore } from '@reduxjs/toolkit';
// Import slices here as you add them, e.g., import exampleReducer from './slices/exampleSlice';

export const store = configureStore({
  reducer: {
    // Add reducers here, e.g., example: exampleReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
